export default {
    en: {
        dashboard: "Dashboard",
        sale: "Sale",
        products: "Products",
        payments: "Payments",
        expenses: "Expenses",
        analysis: "Analysis",
        scanner: "Scanner",
        sellers: "Sellers",
        profile: "Profile",
        currency: "Currency",
        inventory: "Inventory",
    },
    uz: {
        dashboard: "Asosiy",
        sale: "Sotish",
        products: "Mahsulotlar",
        payments: "To'lovlar",
        expenses: "Xarajatlar",
        analysis: "Tahlil",
        scanner: "Skaner",
        sellers: "Sotuvchilar",
        profile: "Profil",
        currency: "To'lov birligi",
        inventory: "Inventarizatsiya",
    },
    ru: {
        dashboard: "Главный",
        sale: "Продажа",
        products: "Продукты",
        payments: "Платежи",
        expenses: "Расходы",
        analysis: "Аналитика",
        scanner: "Сканер",
        sellers: "Sellers",
        profile: "Профиль",
        currency: "Валюта",
        inventory: "Инвентаризация",
    }

}